import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { Loader, Alert } from '@grandvisionhq/common';
import { Types } from '@grandvisionhq/graphql';
import { useFeatureToggles, useIntl } from '@grandvisionhq/state';
import { useDynamicModule } from '@grandvisionhq/utils';

const loadModule = function() {
    var _ref = swcHelpers.asyncToGenerator(function*() {
        const storeModule = yield import(/* webpackChunkName: 'grandvisionhq-stores-v2' */ '@grandvisionhq/stores-v2');
        return storeModule;
    });
    return function loadModule() {
        return _ref.apply(this, arguments);
    };
}();
const usePickupStoresModule = ()=>useDynamicModule(loadModule, '@grandvisionhq/stores-v2', [])
;
const StoresFinderContainer = ({ onPickupStoreSelect  })=>{
    const features = useFeatureToggles();
    const [module, loading, error] = usePickupStoresModule();
    const { getLabel  } = useIntl();
    const onStoreSelect = React__default.useCallback((store)=>{
        onPickupStoreSelect(store);
    }, [
        onPickupStoreSelect
    ]);
    if (loading) {
        return /*#__PURE__*/ React__default.createElement(Loader, null);
    }
    if (error || !module) {
        return /*#__PURE__*/ React__default.createElement(Alert, {
            type: "error",
            notifyScreenReader: false,
            message: getLabel('checkout.pickupStores.error')
        });
    }
    const { Containers , Components , StoreFinderProvider , Util  } = module;
    const { StoreFinder , PickUpButtons , withPickUpButtonsConfig  } = Containers;
    const { StoreListTopContent  } = Components;
    const storeFilter = (store)=>Util.areServicesAvailable(store, [
            Types.ServicesNotAvailable.PICK_UP_IN_STORE
        ])
    ;
    return /*#__PURE__*/ React__default.createElement(StoreFinderProvider, {
        googleMapsId: "google-maps-container",
        hidePhone: !features.isStorePickupPhoneEnabled,
        hideEmail: !features.isStorePickupEmailEnabled,
        storeFilter: storeFilter
    }, /*#__PURE__*/ React__default.createElement(StoreFinder, {
        isInsideModal: true,
        listTopContent: /*#__PURE__*/ React__default.createElement(StoreListTopContent, {
            title: getLabel('checkout.component.storeListTopContent.title'),
            description: getLabel('checkout.component.storeListTopContent.description')
        }),
        buttonsComponent: withPickUpButtonsConfig(PickUpButtons, {
            onStoreSelect
        })
    }));
};

export { StoresFinderContainer };
//# sourceMappingURL=StoresFinderContainer.js.map
